import React from 'react';

import { Segment, Container, Image, Checkbox, Table, Message } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';

import { getUserWaySetting } from './UserWayIntegration.utils';
import { STACK_STATUS_LIVE } from '../../../../constants/constants';
import useWebsite from '../../../../hooks/useWebsiteURL';
import ErrorHandler from '../../../../libs/errors';
import { selectBusinessBrandIdentity } from '../../../../selectors/business';
import { InlineFieldContainer } from '../../../common';
import FormContainer from '../../../common/FormContainer';
import useBranding from '../../../modules/foundation/hooks/use-branding';
import useProviderServiceSettings from '../../../modules/integrations/hooks/use-provider-service-settings';

import UserWayLogo from '../../../../static/logos/userway_logo.png';

function UserWayIntegration() {
  const { providerServiceSettings, updateSetting } = useProviderServiceSettings();
  const brandIdentity = useSelector(selectBusinessBrandIdentity);
  const { getWebsiteStackStatus } = useWebsite();
  const { getSupportEmail } = useBranding();
  const supportEmail = getSupportEmail(brandIdentity);
  const serviceSetting = getUserWaySetting(providerServiceSettings) || {};
  const { statusData } = serviceSetting || {};
  const { enabled } = statusData || {};

  async function handleSettingToggle(e, target) {
    const { checked } = target;

    try {
      updateSetting(serviceSetting.id, {
        status_data: {
          ...statusData,
          enabled: checked,
        },
      });
    } catch (error) {
      ErrorHandler.capture(error);
    }
  }

  function getIntegrationForm() {
    return (
      <Segment>
        <Table>
          <Table.Header>
            <Table.HeaderCell>Global Settings</Table.HeaderCell>
            <Table.HeaderCell textAlign="right">Enabled</Table.HeaderCell>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>Add Userway ADA Widget to Website</Table.Cell>
              <Table.Cell textAlign="right">
                <Checkbox name="website" checked={enabled} onChange={handleSettingToggle} toggle />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Segment>
    );
  }

  if (getWebsiteStackStatus() !== STACK_STATUS_LIVE) return null;

  return (
    <FormContainer loadedKeyPath={['business', 'provider_service_settings']}>
      <InlineFieldContainer title={<h2>UserWay</h2>} enableDelete={false}>
        <Segment.Group>
          <Segment>
            <Container>
              <Container textAlign="center">
                <Image
                  src={UserWayLogo}
                  style={{
                    display: 'inline',
                    margin: '30px',
                    width: '200px',
                  }}
                />
              </Container>
              {!_isEmpty(serviceSetting) ? (
                <>
                  <Container>
                    The UserWay web accessibility widget is an add-on for websites to help improve
                    their compliance with accessibility standards. Enable it here and it will be
                    added to your site on the next publish.
                  </Container>
                  {getIntegrationForm(serviceSetting)}
                </>
              ) : (
                <Container>
                  <Message>
                    The UserWay web accessibility widget is an add-on for websites to help improve
                    their compliance with accessibility standards. This feature has not been
                    provisioned on your account, please contact {supportEmail} to enable this
                    feature.
                  </Message>
                </Container>
              )}
            </Container>
          </Segment>
        </Segment.Group>
      </InlineFieldContainer>
    </FormContainer>
  );
}

export default UserWayIntegration;
